import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaCargosComissaoMP: ['referencia'],
    limpaFiltroConsultaCargosComissaoMP: [],
    receberFiltroConsultaCargosComissaoMP: ['filtroRecebido'],
    setStatusConsultaCargosComissaoMP: ['status'],
})

const INITIAL_STATE = {
    referencia: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_CARGOS_COMISSAO_MP]: setReferencia,
    [Types.LIMPA_FILTRO_CONSULTA_CARGOS_COMISSAO_MP]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CARGOS_COMISSAO_MP]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CARGOS_COMISSAO_MP]: setStatus,
})
